import { toast } from 'react-toastify';

import { getSerializedErrorMessage } from '../../../../../utils/errors';

import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import type { IntakeQuestionnaireState } from '../../types';
import type {
  DeleteIntakeReferralPayload,
  IIntakeReferral,
  IntakeReferralThunks,
} from './types';

export function addIntakeReferralCases(
  builder: ActionReducerMapBuilder<IntakeQuestionnaireState>,
  thunks: IntakeReferralThunks,
) {
  addCreateIntakeReferralCases(builder, thunks);
  addUpdateIntakeReferralCases(builder, thunks);
  addDeleteIntakeReferralCases(builder, thunks);
}

function addCreateIntakeReferralCases(
  builder: ActionReducerMapBuilder<IntakeQuestionnaireState>,
  thunks: IntakeReferralThunks,
) {
  const { createIntakeReferral } = thunks;

  builder
    .addCase(createIntakeReferral.pending, (state) => {
      state.createReferralLoading = true;
      state.error = null;
    })
    .addCase(createIntakeReferral.fulfilled, (state, action: PayloadAction<IIntakeReferral>) => {
      state.createReferralLoading = false;
      if (!state.intakeQuestionnaireDetails) return;
      if (!state.intakeQuestionnaireDetails.referrals) {
        state.intakeQuestionnaireDetails.referrals = [];
      }
      state.intakeQuestionnaireDetails.referrals.push(action.payload);
    })
    .addCase(createIntakeReferral.rejected, (state, action) => {
      state.createReferralLoading = false;
      state.error = action.error;
      toast.error(getSerializedErrorMessage(action.error));
    });
}

function addUpdateIntakeReferralCases(
  builder: ActionReducerMapBuilder<IntakeQuestionnaireState>,
  thunks: IntakeReferralThunks,
) {
  const { updateIntakeReferral } = thunks;

  builder
    .addCase(updateIntakeReferral.pending, (state) => {
      state.updateReferralLoading = true;
      state.error = null;
    })
    .addCase(updateIntakeReferral.fulfilled, (state, action: PayloadAction<IIntakeReferral>) => {
      state.updateReferralLoading = false;
      const list = state.intakeQuestionnaireDetails?.referrals;
      if (!list) return;
      const index = list.findIndex((row) => row.id === action.payload.id);
      if (index !== -1) list[index] = action.payload;
    })
    .addCase(updateIntakeReferral.rejected, (state, action) => {
      state.updateReferralLoading = false;
      state.error = action.error;
      toast.error(getSerializedErrorMessage(action.error));
    });
}

function addDeleteIntakeReferralCases(
  builder: ActionReducerMapBuilder<IntakeQuestionnaireState>,
  thunks: IntakeReferralThunks,
) {
  const { deleteIntakeReferral } = thunks;

  builder
    .addCase(deleteIntakeReferral.pending, (state) => {
      state.deleteReferralLoading = true;
      state.error = null;
    })
    .addCase(
      deleteIntakeReferral.fulfilled,
      (state, action: PayloadAction<void, string, { arg: DeleteIntakeReferralPayload }>) => {
        state.deleteReferralLoading = false;
        if (!state.intakeQuestionnaireDetails) return;
        state.intakeQuestionnaireDetails.referrals = (
          state.intakeQuestionnaireDetails.referrals ?? []
        ).filter((row) => row.id !== action.meta.arg.referralId);
      },
    )
    .addCase(deleteIntakeReferral.rejected, (state, action) => {
      state.deleteReferralLoading = false;
      state.error = action.error;
      toast.error(getSerializedErrorMessage(action.error));
    });
}
